"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var lab_1 = require("@mui/lab");
var AdapterDateFns_1 = __importDefault(require("@mui/lab/AdapterDateFns"));
var LocalizationProvider_1 = __importDefault(require("@mui/lab/LocalizationProvider"));
var MultiselectTextfield_1 = __importDefault(require("atomicComponents/atoms/MultiSelect/MultiselectTextfield"));
var PickersDay_1 = __importDefault(require("atomicComponents/molecules/DatePicker/PickersDay"));
var StaticDatePicker_1 = __importDefault(require("atomicComponents/molecules/DatePicker/StaticDatePicker"));
var validators_1 = require("utils/form/validators");
var DatePicker = function (_a) {
    var // TODO: move to atomicComponents/molecules/DatePicker
    _b = _a.input, name = _b.name, value = _b.value, onChange = _b.onChange, disabled = _b.disabled, restFormInputProps = __rest(_b, ["name", "value", "onChange", "disabled"]), meta = _a.meta, _c = _a.limitToToday, limitToToday = _c === void 0 ? 'NO_PAST' : _c, isStatic = _a.isStatic, minDate = _a.minDate, maxDate = _a.maxDate;
    var today = new Date();
    var errorToShow = (0, validators_1.getErrorToShow)(meta);
    var renderStyledPickerDay = function (date, selectedDates, pickersDayProps) { return (0, jsx_runtime_1.jsx)(PickersDay_1.default, __assign({}, pickersDayProps)); };
    var Component = isStatic ? StaticDatePicker_1.default : lab_1.DatePicker;
    return ((0, jsx_runtime_1.jsx)(LocalizationProvider_1.default, __assign({ dateAdapter: AdapterDateFns_1.default }, { children: (0, jsx_runtime_1.jsx)(Component, { disabled: disabled, inputFormat: "dd/MM/yyyy", value: value || null, onChange: onChange, minDate: minDate !== null && minDate !== void 0 ? minDate : (limitToToday === 'NO_PAST' ? today : null), maxDate: maxDate !== null && maxDate !== void 0 ? maxDate : (limitToToday === 'NO_FUTURE' ? today : null), renderDay: renderStyledPickerDay, renderInput: function (inputProps) { return ((0, jsx_runtime_1.jsx)(MultiselectTextfield_1.default, __assign({ size: "small", variant: "outlined" }, inputProps, restFormInputProps, { name: name, error: !!errorToShow, helperText: errorToShow }))); } }) })));
};
exports.default = DatePicker;
